import TariffBreakdownTable from "./TariffBreakdownTable";

const money = (value) =>
  Number(value || 0).toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });

function surchargeRows(result) {
  const rows = result.pricing.surcharges || [];
  const wanted = ["Maut Deutschland", "Maut International", "Dieselzuschlag", "Versicherung", "Sonstige Zuschlaege"];
  return [
    ...wanted.flatMap((group) => rows.filter((item) => item.group === group || item.label === group)),
    ...rows.filter((item) => !wanted.includes(item.group) && !wanted.includes(item.label)),
  ];
}

export default function TariffResultCard({ result }) {
  if (!result) {
    return (
      <section className="card tariff-result-card tariff-result-empty">
        <h2>Ergebnis</h2>
        <p className="section-text">Nach der Berechnung erscheinen hier Zone, Gewichtsstufe, Grundfracht und Zuschlaege.</p>
      </section>
    );
  }

  if (!result.ok) {
    return (
      <section className="card tariff-result-card">
        <div className="message message-error">
          {result.errors.map((error) => <div key={error}>{error}</div>)}
        </div>
        <TariffBreakdownTable result={result} />
      </section>
    );
  }

  return (
    <section className="card tariff-result-card">
      <div className="section-head">
        <div>
          <h2>Ergebnis</h2>
          <p className="section-text">{result.tariff.carrierName} - {result.tariff.tariffTypeLabel}</p>
        </div>
        <div className="tariff-total-pill">{money(result.pricing.netTotal)} netto</div>
      </div>

      {result.warnings?.length > 0 && (
        <div className="message message-info">
          {result.warnings.map((warning) => <div key={warning}>{warning}</div>)}
        </div>
      )}

      <div className="stats-grid tariff-result-stats">
        <div className="stat-card stat-card-dark"><span className="stat-label">Zone</span><span className="stat-value">{result.breakdown.zone}</span></div>
        <div className="stat-card stat-card-green"><span className="stat-label">Frachtpflichtig</span><span className="stat-value">{result.breakdown.chargeableWeightKg} kg</span></div>
        <div className="stat-card stat-card-gold"><span className="stat-label">Gewichtsstufe</span><span className="stat-value">{result.breakdown.weightBreakKg} kg</span></div>
      </div>

      <TariffBreakdownTable result={result} />

      <div className="table-wrap">
        <table className="data-table tariff-price-table">
          <thead>
            <tr><th>Position</th><th>Berechnung</th><th>Betrag</th></tr>
          </thead>
          <tbody>
            <tr><td>Grundfracht</td><td>Zone {result.breakdown.zone}, {result.breakdown.weightBreakKg} kg</td><td>{money(result.pricing.baseFreight)}</td></tr>
            {surchargeRows(result).map((surcharge, index) => (
              <tr key={`${surcharge.id}-${index}`}>
                <td>{surcharge.label}</td>
                <td>
                  {surcharge.calculation}
                  {surcharge.autoAmount !== undefined && surcharge.overridden && (
                    <div className="section-text">Automatisch: {money(surcharge.autoAmount)}; manuell ueberschrieben</div>
                  )}
                  {surcharge.warning && <div className="section-text">Nicht automatisch berechnet</div>}
                </td>
                <td>{money(surcharge.amount)}</td>
              </tr>
            ))}
            <tr><td>Netto-Gesamtpreis</td><td>Grundfracht plus Maut, Diesel, Versicherung und Zuschlaege</td><td>{money(result.pricing.netTotal)}</td></tr>
            <tr><td>MwSt.</td><td>{Number(result.pricing.vatRate * 100).toLocaleString("de-DE")}%</td><td>{money(result.pricing.vatAmount)}</td></tr>
            <tr><td>Brutto-Gesamtpreis</td><td>Netto plus MwSt.</td><td>{money(result.pricing.grossTotal)}</td></tr>
          </tbody>
        </table>
      </div>

      <p className="section-text tariff-source-note">{result.tariff.sourceNote}</p>
    </section>
  );
}
